import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LivestreamBanner from "@/components/LivestreamBanner";
import Hero from "@/components/sections/Hero";
import Schedule from "@/components/sections/Schedule";
import Location from "@/components/sections/Location";
import Ministries from "@/components/sections/Ministries";
import Beliefs from "@/components/sections/Beliefs";
import Salvation from "@/components/sections/Salvation";
import Sermons from "@/components/sections/Sermons";
import Events from "@/components/sections/Events";
import PrayerForm from "@/components/sections/PrayerForm";
import Giving from "@/components/sections/Giving";
import PraiseWall from "@/components/sections/PraiseWall";
import VerseOfDay from "@/components/sections/VerseOfDay";
import Announcements from "@/components/sections/Announcements";
import MobileApp from "@/components/sections/MobileApp";

export default function Home() {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data || {})).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]">
        <div className="text-[#5C6661]">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAF9F6]" data-testid="home-page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <LivestreamBanner config={content.livestream} />
      <Navbar hideGiving={content?.giving?.hide_giving} />
      <main id="main-content" tabIndex="-1">
        <Hero content={content.hero} />
        <VerseOfDay />
        <Announcements />
        <MobileApp />
        <Schedule content={content.schedule} />
        <Ministries content={content.ministries} />
        <Beliefs content={content.beliefs} />
        <Salvation content={content.salvation} />
        <Sermons />
        <Events />
        <PraiseWall />
        {!content?.giving?.hide_giving && <Giving content={content.giving} />}
        <PrayerForm />
        <Location content={content.location} />
      </main>
      <Footer content={content.footer} location={content.location} services={content.schedule?.services} />
    </div>
  );
}
